import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type CategoryType = OpalApiResponseDocument<
  'ExperimentalReadBlockBFFV1',
  200
>['data']['details']['category_type']

export const categoryTypeFactory: Factory<CategoryType> =
  Factory.define<CategoryType>(
    ({ sequence }) =>
      ({
        id: uuidV4(),
        name: `Category Type ${sequence}`,
        description: null,
        deactivated_at: null,
        supported_paired_type: null,
      }) satisfies CategoryType
  )
